import { group } from '@angular/animations';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { AddCategory, FetchAllCategories } from 'src/app/features/categories/store/categories.actions';
import { AddTag } from 'src/app/features/tags/store/tags.actions';
import { AddBrand } from 'src/app/features/brands/store/brands.actions';
import { ICategory } from 'src/app/features/categories/models/categories.models';
import { combineLatest, map, Observable, of, startWith } from 'rxjs';
import { AddSupplier } from 'src/app/features/suppliers/store/suppliers.actions';
import { AddCompaniesGroupe } from 'src/app/features/companies-groups/store/companies-groups.actions';
import { CatalogsService } from 'src/app/features/catalogs/services/catalogs.services';
import { CommonService } from 'src/app/shared/common.service';
import { TranslateService } from '@ngx-translate/core';

export interface DataType{
  name: string,
  type: string,
  index?: number
}
@Component({
  selector: 'app-add-elements',
  templateUrl: './add-elements.component.html',
  styleUrls: ['./add-elements.component.scss']
})
export class AddElementsComponent implements OnInit {

  form!: FormGroup;
  parent_id!: number;
  categories$: Observable<ICategory[]> = of([]);
  filteredCategories$!: Observable<ICategory[]>;
  categoryControl = new FormControl();
  constructor(
    public dialogRef: MatDialogRef<AddElementsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DataType,
    private fb: FormBuilder,
    private store: Store<AppState>,
    private catalogService: CatalogsService,
    private commonService: CommonService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      name: new FormControl(this.data.name),
    });
    if (this.data.type === 'category') {
      this.store.dispatch(FetchAllCategories({}));
      this.categories$ = this.store.select((state) => state.categories.allCategories)
    };
    this.filteredCategories$ = combineLatest([
      this.categories$,
      this.categoryControl.valueChanges.pipe(
        startWith('')
      ),
    ]).pipe(
      map(([categories, input]) => this._filterStrings(categories, input))
    );
  }

  private _filterStrings(strings: any[], value: string): any[] {
    const filterValue = this._normalizeValue(value);
    return strings.filter((string) =>
      this._normalizeValue(string.name)?.includes(filterValue!)
    );
  }
  private _normalizeValue(value: string | undefined): string | undefined {
    return value?.toLowerCase().replace(/\s/g, '');
  }

  onCategorySelected(category: ICategory) {
    if (category) {
      this.parent_id = category.id
    }
  }

  save(): boolean | void{
    switch (this.data.type) {
      case 'brand':
        this.store.dispatch(AddBrand({brand: this.form.value}))
        break;
      case 'tag':
        this.store.dispatch(AddTag({tag: this.form.value}))
        break;
      case 'category':
        this.store.dispatch(AddCategory({category: {name: this.form.get('name')?.value, parent_id: this.parent_id, image: '', description: ''}}))
        break;
      case 'supplier':
        this.store.dispatch(AddSupplier({supplier: this.form.value, index: this.data.index}))
        break;
      case 'companies_groups.companies_groups':
        this.store.dispatch(AddCompaniesGroupe({payload: this.form.value}))
        break;
      case 'handling_unit_type':
        this.createHandlingUnitType();
        break;
      default:
        return false
    }
    if (this.data.type !== 'handling_unit_type') {
      this.closed()
    }
  }

  private createHandlingUnitType(): void {
    this.catalogService.createHandlingUnitType({ name: this.form.get('name')?.value }).subscribe({
      next: (response) => {
        this.commonService.showToast(
          this.translateService.instant('Handling unit type created successfully'),
          'SUCCESS'
        );
        this.closed();
      },
      error: () => {}
    });
  }

  closed(){
    this.dialogRef.close()
  }

}

